import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { useSEO } from '../hooks/useSEO';

const NotFoundPage = () => {
  useSEO({
    title: 'Page not found',
    description: 'The page you were looking for doesn\'t exist.',
    noindex: true,
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center bg-gray-50 px-4 py-24">
        <div className="max-w-lg w-full text-center">
          <div className="text-7xl font-black text-blue-600 mb-2">404</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            We can&apos;t find that page
          </h1>
          <p className="text-gray-600 mb-8">
            The link may be broken or the page may have moved. Try one of the shortcuts below.
          </p>          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700">
              <Link to="/" data-testid="404-home-link">
                <Home className="h-4 w-4 mr-2" /> Back to home
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link to="/products" data-testid="404-products-link">
                <Search className="h-4 w-4 mr-2" /> Browse products
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
